export function formatInverseAddress(res: any): string | null {
  if (!res) return null;

  const standardAddress = (res?.formatted_addresses?.standard_address || '').trim();
  if (standardAddress) return standardAddress;

  const address = (res?.address || '').trim();
  if (address) return address;

  // 兜底：使用 recommend + 省市区前缀（并做防重复）
  const { province, city, district } = res?.address_component || {};
  const prefix = [province, city, district].filter(Boolean).join('');
  const recommend = (res?.formatted_addresses?.recommend || '').trim();

  if (!prefix) return recommend || null;
  if (!recommend) return prefix;

  return recommend.startsWith(prefix) ? recommend : `${prefix} ${recommend}`;
}
